<template>
  <div class="view contacts" data-name="contacts">
    <FormContent />
    <FakeImages :imageOne="'/static/img/contact_hero1.jpg'" :imageTwo="'/static/img/contact_hero2.jpg'" />
    <PageHero :title="'Contact.'" />
  </div>
</template>

<script>
import FormContent from '@/components/contents/FormContent.vue';
import PageHero from '@/components/heros/PageHero.vue';
import FakeImages from '@/components/contents/FakeImages.vue';

export default {
  name: 'contacts',

  components: {
    FormContent,
    PageHero,
    FakeImages,
  },
};
</script>
